<template>
  <div>

    <v-row class="icoev-header-row fixNotchMarginTop fixNotchPaddingBottom">
			<v-col cols="12" class="icoev-header-title">
				<h4>
					<v-icon color="primary" style="top: -2px;">mdi-school</v-icon>
					Formación
				</h4>
			</v-col>
    </v-row>

    <div class="icoev-main-content-wrapper fixNotchMarginTop fixNotchPaddingBottom">

			<v-card
				outlined
				class="mx-auto"
				max-width="95%"
				style="margin-top: 16px;">
				<v-card-text style="padding: 0;">
					<v-list style="padding: 0;">
						<v-list-item @click="openDetalleFormacion()">
							<v-list-item-content>
								<v-list-item-title style="white-space: normal; color: #065535; font-size: 16px; font-weight: 700;">Cursos disponibles</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon color="primary">mdi-cast-education</v-icon>
							</v-list-item-action>
						</v-list-item>
						<v-divider/>
						<v-list-item @click="openUrl('https://www.icoev.es/el-colegio-informa/rido_revistasybibliotecas/')">
							<v-list-item-content>
								<v-list-item-title style="white-space: normal; color: #065535; font-size: 16px; font-weight: 700;">Revistas y artículos científicos</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon color="primary">mdi-open-in-new</v-icon>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>

			<h4 class="primary--text pt-10 pl-4">Más información</h4>

			<v-card
				outlined
				class="mx-auto"
				max-width="95%"
				style="margin-top: 16px;">
				<v-card-text style="padding: 0;">
					<v-list style="padding: 0;">
						<v-list-item @click="openUrl('https://ecolegio.es/formacion/course/index.php?categoryid=3')">
							<v-list-item-content>
								<v-list-item-title style="white-space: normal; font-size: 14px;">Webinars gratuitos FDE</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon color="primary">mdi-open-in-new</v-icon>
							</v-list-item-action>
						</v-list-item>
						<v-divider/>
						<v-list-item @click="openUrl('https://www.centroestudiosoe.es/')">
							<v-list-item-content>
								<v-list-item-title style="white-space: normal; font-size: 14px;">Centro de Estudios Odontoestomatológicos</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon color="primary">mdi-open-in-new</v-icon>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
		</div>
  </div>

</template>

<script>
import BaseModule from "../../common/BaseModule";
import cordova from "../../../api/cordova";
import discovery from '../../../discovery';

export default {
  name: 'FormacionMain',
  mixins: [ BaseModule ],
  data () {
		return {
		}
	},
  mounted() {
		this.$nextTick(() => {
			window.$vue.$on('ne_awake', this.processAwake);

			window.$vue.$off('ne_backbutton');
			window.$vue.$on('ne_backbutton', this.processBackButton);
		});
  },
	methods: {
		processAwake: function(seconds) {
			this.$log.debug("FormacionMain - processAwake: " + seconds + " secs");
		},
		processBackButton: function() {
			window.$vue.$off('ne_backbutton');
			this.$router.go(-1);
		},
		openDetalleFormacion: function() {
			this.$emit('open-formacion-dialog');
		},
		openUrl(url) {
			if (url == 'https://www.icoev.es/el-colegio-informa/rido_revistasybibliotecas/') {
				url = this.getRedirectUrl(url);
			}

			if (this.$store.state.icoev.device.platform == 'browser') {
				window.open(url);
			} else {
				cordova.openUrl(encodeURI(url));
			}
		},
		getRedirectUrl(target) {
			return discovery.icoev_service_url+"users/redirect/"+this.$store.state.icoev.redirectToken+"?t="+target;
		},
	},
}
</script>